const value = {
    pageTitle: 'Управление пользователями',
    login: 'Логин',
    email: 'Почта',
    fio: 'ФИО',
    role: 'Роль',
    creationType: 'Тип создания',
    active: 'Активен',
    action: 'Действия',
    systemRole: 'Системная роль',
    status: 'Статус',
    creationTypeLocal: 'Локальный',
  };

export default value;
